import React from "react";
import "./style.css";
import UsersImage from "../../Images/signIn/user.png";
import PwImage from "../../Images/signIn/pw.png";
import Logo from "../../Images/logo.png";
import { Label } from "reactstrap";
import { Button, Input, message } from "antd";
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  LockOutlined,
} from "@ant-design/icons";
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import { Form, DatePicker } from "antd";

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      signInEmail: "",
      signInPassword: "",
      errors: {},
      userData: this.props.data,
      loadings: [],
      isForgotPassword: false,
      dob: null,
      showPasswordEnteries: false,
      password1: "",
      password2: "",
    };
  }

  componentDidMount() {
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData) {
      this.props.setloginStatusTrue(userData, userData.password);
    }
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        this.recruitSignin();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }

  onEmailChange = (event) => {
    this.setState({ signInEmail: event.target.value });
  };
  handleChange = (value) => {
    if (value) {
      const dateFormat = value.format("YYYY-MM-DD");
      this.setState({ dob: dateFormat });
    }
  };

  onPasswordChange = (event) => {
    this.setState({ signInPassword: event.target.value });
  };
  onPassword1Change = (event) => {
    this.setState({ password1: event.target.value });
  };
  onPassword2Change = (event) => {
    this.setState({ password2: event.target.value });
  };

  cancel = () => {
    this.setState({
      showPasswordEnteries: false,
      password1: "",
      password2: "",
      signInEmail: "",
      dob: null,
      isForgotPassword: false,
    });
  };

  forgotPassword = () => {
    console.log("forgot password");
    if (!this.state.signInEmail) {
      alert("Enter email first");
    } else {
      if (this.state.showPasswordEnteries) {
        if (
          this.state.password1 &&
          this.state.password2 &&
          this.state.password1 === this.state.password2
        ) {
          console.log(
            "password matched, fetching with password",
            this.state.password1
          );
          fetch(
            "https://work-web-server.herokuapp.com/hiring/applicants/forgotPassword",
            //"http://localhost:5000/hiring/applicants/forgotPassword",
            {
              method: "post",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                email: this.state.signInEmail,
                dob: this.state.dob,
                password: this.state.password1,
              }),
            }
          )
            .then((response) => response.json())
            .then((res) => {
              console.log(res);
              if (res === "Applicant not found") {
                console.log("Invalid Enteries");
                alert("Invalid Enteries");
              } else if (res === "Applicant found") {
                console.log("Show Password Enteries");
                this.setState({ showPasswordEnteries: true });
              } else if (res === "Password Updated") {
                console.log("Password Updated");
                message.success("Password Updated");
                this.setState({
                  isForgotPassword: false,
                  showPasswordEnteries: false,
                  password1: "",
                  password2: "",
                  dob: null,
                  signInEmail: "",
                  signInPassword: "",
                });
              }
            });
        } else {
          message.warning("Passwords do not match");
        }
      } else {
        console.log("No password");
        fetch(
          "https://work-web-server.herokuapp.com/hiring/applicants/forgotPassword",
          //"http://localhost:5000/hiring/applicants/forgotPassword",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email: this.state.signInEmail,
              dob: this.state.dob,
            }),
          }
        )
          .then((response) => response.json())
          .then((res) => {
            console.log(res);
            if (res === "Applicant not found") {
              console.log("Invalid Enteries");
              alert("Invalid Enteries");
            } else if (res === "Applicant found") {
              console.log("Show Password Enteries");
              this.setState({ showPasswordEnteries: true });
            }
          });
      }
    }
  };

  recruitSignin = () => {
    this.setState(({ loadings }) => {
      const newLoadings = [...loadings];
      newLoadings[0] = true;

      return {
        loadings: newLoadings,
      };
    });

    fetch(
      "https://work-web-server.herokuapp.com/hiring/applicants/login",
      // `https://192.168.2.66:11013/rest_api/mobile/getApplicantByEmailAndPassword/${this.state.signInEmail}/${this.state.signInPassword}`
      // "http://localhost:5000/hiring/applicants/login",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: this.state.signInEmail,
          password: this.state.signInPassword,
        }),
      }
    )
      .then((response) => response.json())
      .then((user) => {
        console.log(user);
        if (user._id) {
          this.setState({
            userData: user,
          });
          setTimeout(() => {
            this.setState(({ loadings }) => {
              const newLoadings = [...loadings];
              newLoadings[0] = false;

              return {
                loadings: newLoadings,
              };
            });
          }, 6000);
          this.props.setloginStatusTrue(user, this.state.signInPassword);
          localStorage.setItem("userData", JSON.stringify(user));
        } else {
          this.setState({
            errors: user,
          });
          setTimeout(() => {
            this.setState(({ loadings }) => {
              const newLoadings = [...loadings];
              newLoadings[0] = false;

              return {
                loadings: newLoadings,
              };
            });
          }, 0);
        }
      });
  };

  render() {
    const { errors } = this.state;
    return (
      <div className="signPage">
        <div className="signinButtonContainer tc">
          <div className="signinLogo animate__animated animate__rotateIn">
            <a href="https://w4work.com/">
              <img src={Logo} alt="Logo " width="100px" />
            </a>
          </div>
          <img src={UsersImage} alt="Locked" width="20px" />
          <Input
            className="signinInput input-reset animate__animated animate__lightSpeedInLeft"
            type="email"
            name="employee_id"
            id="employee_id"
            placeholder="Employee ID"
            onChange={this.onEmailChange}
          />
          <Label className="red">{errors.email}</Label>
          <br />
          <img src={PwImage} alt="Locked" width="20px" />
          <Input.Password
            className="signinInput input-reset animate__animated animate__lightSpeedInRight"
            placeholder="Input Password"
            onChange={this.onPasswordChange}
            id="password"
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
          <Label className="red">{errors.password}</Label>
          <br />
          <Button
            className="signinButtonLogin animate__animated animate__lightSpeedInLeft"
            loading={this.state.loadings[0]}
            onClick={this.recruitSignin}
          >
            Sign in
          </Button>
          <br />
          <br />
          <Button
            type="primary"
            style={{
              backgroundColor: "white",
              color: "black",
              borderColor: "black",
            }}
            onClick={() => {
              this.setState({ isForgotPassword: true });
            }}
          >
            Forgot Password
          </Button>
          <br />
          <Modal show={this.state.isForgotPassword}>
            <Form
              scrollToFirstError={true}
              initialValues={{ remember: true }}
              onFinish={this.onFinish}
              labelAlign="left"
            >
              <ModalHeader>
                <ModalTitle>Forgot Password</ModalTitle>
              </ModalHeader>
              <ModalBody>
                <Form.Item
                  name="employee_id"
                  rules={[
                    {
                      type: "email",
                      message: "The input is not a valid E-mail!",
                    },
                    {
                      required: true,
                      message: "Please enter your name!",
                    },
                  ]}
                >
                  <Input
                    type="email"
                    name="employee_id"
                    id="employee_id"
                    value={this.state.email}
                    onChange={this.onEmailChange}
                    placeholder="Employee ID"
                  />
                </Form.Item>
                <Label>Security Question</Label>
                <Form.Item
                  name="dob"
                  label="DOB"
                  rules={[
                    {
                      required: true,
                      message: "Please select your DOB!",
                    },
                  ]}
                >
                  <DatePicker name="dob" onChange={this.handleChange} />
                </Form.Item>

                {this.state.showPasswordEnteries ? (
                  <div>
                    <Form.Item
                      name="password"
                      label="Create Password"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your Password!",
                        },
                      ]}
                      hasFeedback
                    >
                      <Input.Password
                        name="password"
                        value={this.state.password}
                        onChange={this.onPassword1Change}
                        prefix={
                          <LockOutlined className="site-form-item-icon" />
                        }
                        type="password"
                        placeholder="Password"
                      />
                    </Form.Item>
                    <Label className="red">{errors.password2}</Label>
                    <Form.Item
                      name="password2"
                      label="Confirm Password"
                      dependencies={["password"]}
                      rules={[
                        {
                          required: true,
                          message:
                            "Please enter your password again for confirmation!",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue("password") === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject("Passwords do not match");
                          },
                        }),
                      ]}
                      hasFeedback
                    >
                      <Input.Password
                        name="password2"
                        value={this.state.password2}
                        onChange={this.onPassword2Change}
                        prefix={
                          <LockOutlined className="site-form-item-icon" />
                        }
                        type="password"
                        placeholder="Re-Enter Password"
                      />
                    </Form.Item>
                  </div>
                ) : null}
              </ModalBody>
              <ModalFooter>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    borderColor: "black",
                  }}
                  onClick={this.forgotPassword}
                >
                  {!this.state.showPasswordEnteries
                    ? "Submit"
                    : "Update Pasword"}
                </Button>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    borderColor: "black",
                  }}
                  onClick={this.cancel}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </Form>
          </Modal>

          <Label className="signinButtonLabel tc animate__animated animate__lightSpeedInRight">
            Beta Phase
            <b>(2.3)</b>
          </Label>
        </div>
      </div>
    );
  }
}

export default Login;
